module.exports = __webpack_public_path__ + "img/uefa-europa-league-113.c968eefb.png";